import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import itx from "../assets/itx.png";
import Breadcrumb from "../components/Breadcrumb";
import ChatBubble from "../components/ChatBubble";
import Header from "../components/Header";
import Nav from "../components/Nav";
import SearchComponent from "../components/SearchComponent";
import Sidebar from "../components/sidebar/Sidebar";
import {FORMS, MODULES, pathToModuleNameAndDescriptionMap, searchTagConst} from "../const";
import useFirstModule from "../hooks/useFirstModule";
import { getLatestReleaseNote } from "../api/releaseNoteApi";
import ReleaseNotePopup from "../components/release-note/ReleaseNotePopup";
import {useSelector} from "react-redux";

import { IoChatbubblesSharp } from "react-icons/io5";
import Draggable from "react-draggable";

function Layout() {
  const [showSearch, setShowSearch] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const [isFooterRed, setIsFooterRed] = useState(false);
  const [isSearchVisible, setIsSearchVisible] = useState(true);
  const location = useLocation();
  const pathname = location.pathname;
  const [moduleName, setModuleName] = useState(
    pathToModuleNameAndDescriptionMap[pathname]?.moduleName,
  );
  const [description, setDescription] = useState(
    pathToModuleNameAndDescriptionMap[pathname]?.description,
  );

  const [fullScreen, setFullScreen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [chatPos, setChatPos] = useState({ x: 0, y: 0 });
  const [dragStartPos, setDragStartPos] = useState({ x: 0, y: 0 });
  const [latestVersion, setLatestVersion] = useState("");
  const storedModule = localStorage.getItem("selectedItem");
  const [showReleasePopup, setShowReleasePopup] = useState(false);
  const firstAuthModule = useFirstModule(
    storedModule
      ? storedModule === "Mission-control"
        ? "Master"
        : storedModule
      : "Master",
  );
  const [selectedCategory, setSelectedCategory] = useState(firstAuthModule);

  useEffect(() => {
    setSelectedCategory(firstAuthModule);
  }, [firstAuthModule]);

  const auth = useSelector((state) => state.user.permissions[MODULES.Master]);
  const viewReleasePermission=
      auth?.[FORMS?.HELP_CENTER?.RELEASE_NOTE_POPUP?.form]?.FORM?.VIEW;


  useEffect(() => {
    if (pathname === "/mission-control") {
      setFullScreen(true);
    } else if (pathname === "/master/vehicle") {
      switch (location.hash) {
        case searchTagConst.vehicle.VEHICLE: {
          setModuleName("Vehicle Single");
          setDescription("This is the form to update vehicle details");
          break;
        }
        case searchTagConst.vehicle.VEHICLE_CONFIG: {
          setModuleName("Vehicle Config");
          setDescription("This is the form to update vehicle config");
          break;
        }
        case searchTagConst.vehicle.VEHICLE_DOCS: {
          setModuleName("Vehicle Docs");
          setDescription("This is the form to update vehicle documents");
          break;
        }
        case searchTagConst.vehicle.VEHICLE_OPERATIONS: {
          setModuleName("Vehicle Operations");
          setDescription("TThis is the form to update vehicle operations");
          break;
        }
        case searchTagConst.vehicle.VEHICLE_TYPES: {
          setModuleName("Vehicle Types");
          setDescription("This is the form to update vehicle types");
          break;
        }
        case searchTagConst.vehicle.VEHICLE_CHECKUP: {
          setModuleName("Vehicle Checkups");
          setDescription("This is the form to update vehicle checkups");
          break;
        }
        default: {
          setModuleName("Vehicle Creation");
          setDescription("This is the form to create vehicles");
        }
      }
    } else {
      setFullScreen(false);
      let moduleInfo = pathToModuleNameAndDescriptionMap[pathname];
      if (!moduleInfo && pathname.startsWith("/mis/report-generator/queue/")) {
        moduleInfo =
          pathToModuleNameAndDescriptionMap["/mis/report-generator/queue"];
      }

      setModuleName(moduleInfo?.moduleName);
      setDescription(moduleInfo?.description);
    }
  }, [location.hash, pathname]);

  useEffect(() => {
    const fetchLatest = async () => {
      try {
        const res = await getLatestReleaseNote();
        if (res) {
          setLatestVersion(res.version);
        }
      } catch (e) {
      }
    };

    fetchLatest();
  }, []);
  console.log(selectedCategory);

  const handleNavItemClick = (category) => {
    setSelectedCategory(category);
    openSidebar(); // Notify to open the sidebar
  };

  const handleSearchToggle = () => {
    setShowSearch(!showSearch);
  };

  const handleSidebarCollapseToggle = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const handleSidebarItemClick = (label, description) => {
    // setModuleName(label + appendValue);
    // setModuleDescription(description);
    setIsSidebarCollapsed(true);
  };

  const openSidebar = () => {
    setIsSidebarCollapsed(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const mainContainer = document.querySelector(".main");

      // Check if the main container is found
      if (mainContainer) {
        setIsFooterRed(mainContainer.scrollTop > 0);
      }
    };

    // Add event listener for scroll
    window.addEventListener("scroll", handleScroll);

    // Remove event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="layout-container">
      <div className={fullScreen ? "full-screen-container" : "container"}>
        <div className="header-layout">
          <Header
            isSearchVisible={isSearchVisible}
            setIsSearchVisible={setIsSearchVisible}
            onSearchToggle={handleSearchToggle}
            isSidebarCollapsed={isSidebarCollapsed}
          />
        </div>
        {fullScreen ? (
          <Outlet />
        ) : (
          <>
            <div className="nav">
              <Nav
                onNavItemClick={handleNavItemClick}
                selectedCategory={selectedCategory}
                openSidebar={openSidebar}
              />
            </div>
            <div className="main-container">
              <div className="sidebar-layout">
                <Sidebar
                  selectedCategory={selectedCategory}
                  onCollapseToggle={handleSidebarCollapseToggle}
                  onSidebarItemClick={handleSidebarItemClick}
                  isSidebarCollapsed={isSidebarCollapsed}
                />
              </div>
              <div className={`main ${isFooterRed ? "red" : ""}`}>
                <Breadcrumb />
                <h1 style={{ margin: "2px 0 2px 0px" }}>{moduleName}</h1>
                <p style={{ marginBottom: "5px" }}>{description}</p>
                <Outlet />
                <ChatBubble
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  isMinimized={isMinimized}
                  setIsMinimized={setIsMinimized}
                  chatPos={chatPos}
                />
                {(!isOpen || isMinimized) && (
                  <Draggable
                    bounds="body"
                    defaultPosition={chatPos}
                    onStart={(e, data) => setDragStartPos({ x: data.x, y: data.y })}
                    onStop={(e, data) => {
                      setChatPos({ x: data.x, y: data.y });
                      const dx = data.x - dragStartPos.x;
                      const dy = data.y - dragStartPos.y;
                      if (Math.abs(dx) < 5 && Math.abs(dy) < 5) {
                        setIsOpen(true);
                        setIsMinimized(false);
                      }
                    }}
                  >
                    <button
                      style={{
                        position:       "fixed",
                        bottom:         "70px",
                        right:          "20px",
                        background:     "#00bcd4",
                        color:          "white",
                        width:          "50px",
                        height:         "50px",
                        borderRadius:   "50%",
                        display:        "flex",
                        alignItems:     "center",
                        justifyContent: "center",
                        border:         "none",
                        cursor:         "pointer",
                        boxShadow:      "0 4px 12px rgba(3, 245, 245, 0.73)",
                        zIndex:         1200,
                        padding:        0,
                      }}
                      title="OKIDOKI Assistant"
                    >
                      <IoChatbubblesSharp style={{ fontSize: "24px" }} />
                    </button>
                  </Draggable>
                )}
              </div>
            </div>
          </>
        )}
      </div>
      <div className={`footer ${isFooterRed ? "red" : ""}`}>
        <h5 style={{ margin: 0, padding: "0 10px 0 0", color: "gray" }}>
          Powered by
        </h5>
        <div
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <img
            src={itx}
            alt="footer"
          />
          <div
  style={{
    position: "fixed",
    bottom: "10px",
    left: "20px",
    color: "#C72127",
    fontSize: "14px",
    fontWeight: "600",
    cursor: viewReleasePermission ? "pointer" : "default",
    zIndex: 9999,
  }}
  onClick={
    viewReleasePermission
        ? () => setShowReleasePopup(true)
        : undefined
  }


>
  Version {latestVersion || "v1.0.0"}
</div>
          <div className="particle-container">
            <div className="particle" style={{ top: "5%", left: "5%" }}></div>
            <div className="particle" style={{ top: "10%", left: "10%" }}></div>
            <div className="particle" style={{ top: "20%", left: "40%" }}></div>
            <div className="particle" style={{ top: "30%", left: "70%" }}></div>
            <div className="particle" style={{ top: "50%", left: "20%" }}></div>
            <div className="particle" style={{ top: "70%", left: "50%" }}></div>
            <div className="particle" style={{ top: "90%", left: "80%" }}></div>
          </div>
        </div>
      </div>

      {showSearch && (
        <SearchComponent
          onClose={handleSearchToggle}
          setIsSearchVisible={setIsSearchVisible}
        />
      )}
      {showReleasePopup && (
          <ReleaseNotePopup onClose={() => setShowReleasePopup(false)} />
        )}
    </div>

  );
}

export default Layout;
